import script from "./AddParentChild.vue?vue&type=script&setup=true&lang=js"
export * from "./AddParentChild.vue?vue&type=script&setup=true&lang=js"

import "./AddParentChild.vue?vue&type=style&index=0&id=381bcc03&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-381bcc03"]])

export default __exports__